import { render, staticRenderFns } from "./202408.vue?vue&type=template&id=2c40d300&scoped=true&"
import script from "./202408.vue?vue&type=script&lang=js&"
export * from "./202408.vue?vue&type=script&lang=js&"
import style0 from "./202408.vue?vue&type=style&index=0&id=2c40d300&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c40d300",
  null
  
)

export default component.exports